<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div class="reportes-container">
    <h1 class="title">{{'CLIENTS_REPORT' | translate}}</h1>
    
    <div class="form-card">

      <!-- Tabs de Bootstrap -->
      <ul class="nav nav-tabs">
        <li class="nav-item" *ngFor="let tab of tabs">
          <button 
            class="nav-link" 
            [class.active]="tab.activo"
            (click)="cambiarTab(tab.id)">
            <span class="icono-tab">{{ tab.icono }}</span>
            {{ tab.label | translate }}
          </button>
        </li>
      </ul>

      <!-- Contenido de los Tabs -->
      <div class="tab-content">
        <div class="tab-pane" [class.active]="tabActiva === 'planes-sin-beneficiario'">
          <app-active-plans-without-beneficiaries></app-active-plans-without-beneficiaries>
        </div>

        <div class="tab-pane" [class.active]="tabActiva === 'reporte-2'">
          <div class="placeholder-reporte">
            <h3>🚧 Reporte 2 en Desarrollo</h3>
            <p>Este reporte estará disponible próximamente.</p>
          </div>
        </div>

        <div class="tab-pane" [class.active]="tabActiva === 'reporte-3'">
          <div class="placeholder-reporte">
            <h3>🚧 Reporte 3 en Desarrollo</h3>
            <p>Este reporte estará disponible próximamente.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>